import { Auth } from "./Auth";
import { Configuration } from "Configuration";
import { AppContext } from "./AppContext";
import { User } from "oidc-client-ts";

import { ApplicationInsights } from "@microsoft/applicationinsights-web";

import { Router } from "./Router";
import { Navigation } from "./Navigation";
import { Util } from "./Util";

/**
 * @hidden
 */
export class App {
    public auth: Auth;

    public static current: App;

    public appContext: AppContext;

    public router: Router;

    constructor() {
        App.current = this;
        this.appContext = new AppContext();
    }

    private appInsights: ApplicationInsights;

    public isDmsConfig: boolean;

    public async init(container: JQuery, baseUrl: string, isDmsConfig: boolean): Promise<void> {
        let root = baseUrl + "/";
        this.isDmsConfig = isDmsConfig;
        if (isDmsConfig) {
            root += "DMSConfig/";
        }
        Navigation.setRoot(root);

        this.auth = new Auth();
        this.auth.setUserRefreshCallback((user: User) => {
            this.appContext.appViewModel.set("username", user.profile.nickname);
            this.appContext.appViewModel.set("usernameinitials", Util.getInitials(user.profile.nickname));
            this.appContext.appViewModel.set("hasPassword", user.profile.hasPassword);
            if (user.profile.picture) {
                this.appContext.appViewModel.set("picture", "data:image/png;base64," + user.profile.picture);
            } else {
                this.appContext.appViewModel.set("picture", undefined);
            }
        });
        let user: User = null;
        if (isDmsConfig) {
            user = await this.auth.init(baseUrl, "dms-config");
            if (!user) {
                return;
            }
        } else {
            user = await this.auth.init(baseUrl, "dms-web");

            if (!user) {
                return;
            }
        }

        if (isDmsConfig) {
            Configuration.baseUrl = baseUrl + "/dmsconfig";
            Configuration.isDmsConfig = true;
        } else {
            Configuration.baseUrl = baseUrl;
        }

        await this.appContext.initialize();

        if (this.appContext.environment.AppInsightsInstrumentationKey) {
            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: this.appContext.environment.AppInsightsInstrumentationKey,
                },
            });
            this.appInsights.loadAppInsights();
            this.appInsights.setAuthenticatedUserContext(user.profile.preferred_username);
            this.appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
        }

        this.router = new Router();
        this.router.initialize(container, root, this.appInsights);
        this.router.start();
    }
}
